import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBarAction, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-app-update-available',
  imports: [MatButton, MatIcon, MatSnackBarAction],
  templateUrl: './app-update-available.component.html',
  styleUrl: './app-update-available.component.scss',
})
export class AppUpdateAvailableComponent {
  private snackBarRef = inject<MatSnackBarRef<AppUpdateAvailableComponent>>(MatSnackBarRef);

  public onAction(): void {
    this.snackBarRef.dismissWithAction();
  }
}
